"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldContainer = void 0;
const React = __importStar(require("react"));
const type_1 = require("../../../type");
const Field_Constant_1 = require("../utils/Field.Constant");
const Field_Storage_1 = require("../utils/Field.Storage");
const Field_Style_1 = require("../utils/Field.Style");
const Field_Error_1 = require("./Field.Error");
const Field_RenderNonEdit_1 = require("./Field.RenderNonEdit");
const FieldContainer = (props) => {
    var _a, _b, _c, _d;
    if (typeof props.isEdit === type_1.TYPE_FUNCTION ? props.isEdit(props) : props.isEdit) {
        return (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-wrapper ${typeof props.classNameWrapper === type_1.TYPE_FUNCTION
                ? props.classNameWrapper(props)
                : props.classNameWrapper}`, key: `${Field_Constant_1.TEXT_AUTHOR}-field-text-${props.index}` },
            React.createElement("div", { style: props.required && props.showSymbol ? Field_Style_1.STYLE_REQUIRED_FIELD_FLEX : {} },
                React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-label ${props.classNameLabel}` }, typeof props.label === type_1.TYPE_FUNCTION
                    ? props.label(props)
                    : props.label),
                props.required && props.showSymbol ? (React.createElement("div", { style: Field_Style_1.STYLE_REQUIRED_RED_STAR }, Field_Constant_1.SIGN_REQUIRED)) : (React.createElement(React.Fragment, null))),
            React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-sub-label ${typeof props.classNameSubLabel === type_1.TYPE_FUNCTION
                    ? props.classNameSubLabel(props)
                    : props.classNameSubLabel}` }, typeof props.subLabel === type_1.TYPE_FUNCTION
                ? props.subLabel(props)
                : props.subLabel),
            props.inputBody,
            React.createElement(Field_Storage_1.FieldStorage, { FieldReference: props.FieldReference, name: props.name, value: props.value, FunctionGetThisValue: props.FunctionGetThisValue, index: props.index, reference: props.reference, fieldIndex: props.fieldIndex, grandParentIndex: props.grandParentIndex, grandParentKey: props.grandParentKey, parentIndex: props.parentIndex, parentKey: props.parentKey, childType: props.childType }),
            props.renderFooter && props.renderFooter(props),
            props.showError && (React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.renderError) ? (props === null || props === void 0 ? void 0 : props.renderError({
                error: (_a = props === null || props === void 0 ? void 0 : props.FunctionGetThisValue) === null || _a === void 0 ? void 0 : _a.message,
            })) : (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-error ${typeof props.classNameError === type_1.TYPE_FUNCTION
                    ? props.classNameError({
                        error: (_b = props === null || props === void 0 ? void 0 : props.FunctionGetThisValue) === null || _b === void 0 ? void 0 : _b.message,
                    })
                    : props.classNameError}` }, ((_c = props === null || props === void 0 ? void 0 : props.FunctionGetThisValue) === null || _c === void 0 ? void 0 : _c.error) && (React.createElement(Field_Error_1.FieldError, { message: (_d = props === null || props === void 0 ? void 0 : props.FunctionGetThisValue) === null || _d === void 0 ? void 0 : _d.message }))))))));
    }
    else if (props.render) {
        return props.render({
            value: props.value,
            loading: props.loading,
        });
    }
    else {
        return (React.createElement(Field_RenderNonEdit_1.FieldRenderNoneEdit, { classNameLabel: props.classNameLabel, classNameValue: props.classNameValue, label: props.label, value: props.value, classNameSubLabel: props.classNameSubLabel, subLabel: props.subLabel, classNameWrapper: props.classNameWrapper }));
    }
};
exports.FieldContainer = FieldContainer;
